module.exports = __webpack_public_path__ + "media/icons/times-d3b0b1ec.svg";